export const productText = {
  headline: "recommendations.headline_product",
  sfp_a: "recommendations.product_text_1", // Similar Flavour Profile (Accesible)
  sfp_e: "recommendations.product_text_2", // Similar Flavour Profile (hard to get / more exclusive)
  p_so: "recommendations.product_text_3", // Premiumise / Special Occasion (accessible)
  svd: "recommendations.product_text_4", // Something very different (flavour)
  ps: "", // Perfect Serve (The Macallan estate serve)
  pe: "", // Perfect Experience (City and SH focus)
};

// verb used in product question
export const productQuestions = {
  whiskies_owned: "recommendations.product_category_verb_1",
  whiskies_experienced: "recommendations.product_category_verb_2",
  desired_products: "recommendations.product_category_verb_3",
  whiskies_purchased_regularly: "recommendations.product_category_verb_4",
};

export const categories = {
  cta: {
    // Call to action
    quantity: 1,
    headline: "recommendations.headline_cta",
  },
  brand: {
    quantity: 3,
    headline: "recommendations.headline_brand",
  },
  product: {
    quantity: 3,
    headline: "recommendations.headline_products",
  },
  estate: {
    quantity: 3,
    headline: "recommendations.headline_estate",
  },
  partnership: {
    quantity: 3,
    headline: "recommendations.headline_partnership",
  },
  fallback: {
    quantity: 999,
    headline: "recommendations.headline_fallback",
  },
};

const productUrl = {
  1: "https://www.themacallan.com/classic-cut-2021-edition",
  2: "https://www.themacallan.com/sherry-oak-18-years-old",
  3: "https://www.themacallan.com/double-cask-12-years-old",
  4: "https://www.themacallan.com/whisky/single-malts/rare-cask",
  5: "https://www.themacallan.com/gran-reserva-15-years-old",
  6: "https://www.themacallan.com/whisky/single-malts/sherry-oak-25-years-old-2021-release",
  7: "https://www.themacallan.com/double-cask-18-years-old",
  8: "https://www.themacallan.com/the-macallan-quest-whisky",
  9: "https://www.themacallan.com/en/whisky/single-malts/sherry-oak/sherry-oak-12-years-old",
  10: "https://www.themacallan.com/whisky/single-malts/macallan-estate",
  11: "https://www.themacallan.com/triple-cask-matured-15-years-old",
  12: "https://www.themacallan.com/the-macallan-sienna",
  13: "https://www.themacallan.com/the-macallan-terra-whisky",
  14: "https://www.themacallan.com/triple-cask-matured-18-years-old",
  15: "https://www.themacallan.com/the-macallan-fine-oak-17-years-old",
  16: "https://www.themacallan.com/single-malts/limited-releases/anecdotes-of-ages/an-estate-a-community-and-a-distillery",
  17: "https://www.themacallan.com/rare-cask-black-product",
  18: "https://www.themacallan.com/the-macallan-ruby",
  19: "https://www.themacallan.com/classic-cut-2018-edition",
  20: "https://www.themacallan.com/the-macallan-lumina-whisky",
  21: "https://www.themacallan.com/classic-cut-2017-release",
  22: "https://www.themacallan.com/the-macallan-fine-oak-18-years-old",
  23: "https://www.themacallan.com/whisky/single-malts/rare-cask/rare-cask-2021-release",
  24: "https://www.themacallan.com/single-malts/limited-releases/easter-elchies-black",
  25: "https://www.themacallan.com/whisky/single-malts/the-masters-decanter-series/m-black-2020-release",
  26: "https://www.themacallan.com/triple-cask-matured-12-years-old",
  27: "https://www.themacallan.com/double-cask-15-years-old",
  28: "https://www.themacallan.com/the-macallan-fine-oak-12-years-old",
  29: "https://www.themacallan.com/whisky/single-malts/sherry-oak/sherry-oak-12-years-old",
  30: "https://www.themacallan.com/the-macallan-amber",
};

export const productRecommendations = [
  {
    code: "MAC001",
    recommendations: {
      sfp_a: productUrl[1],
      p_so: productUrl[2],
      svd: productUrl[3],
    },
  },
  {
    code: "MAC003",
    recommendations: {
      sfp_a: productUrl[4],
      sfp_e: productUrl[5],
      p_so: productUrl[6],
      svd: productUrl[7],
    },
  },
  {
    code: "MAC004",
    recommendations: {
      sfp_a: productUrl[8],
      p_so: productUrl[3],
      svd: productUrl[9],
    },
  },
  {
    code: "MAC005",
    recommendations: {
      sfp_a: productUrl[8],
      p_so: productUrl[10],
      svd: productUrl[1],
    },
  },
  {
    code: "MAC194",
    recommendations: {
      sfp_a: productUrl[11],
      sfp_e: productUrl[12],
      p_so: productUrl[7],
      svd: productUrl[13],
    },
  },
  {
    code: "MAC195",
    recommendations: {
      sfp_a: productUrl[14],
      sfp_e: productUrl[15],
      p_so: productUrl[16],
      svd: productUrl[2],
    },
  },
  {
    code: "MAC006",
    recommendations: {
      p_so: productUrl[11],
      svd: productUrl[17],
    },
  },
  {
    code: "MAC007",
    recommendations: {
      p_so: productUrl[10],
      svd: productUrl[17],
    },
  },
  {
    code: "MAC008",
    recommendations: {
      svd: productUrl[17],
    },
  },
  {
    code: "MAC009",
    recommendations: {
      sfp_e: productUrl[18],
      svd: productUrl[17],
    },
  },
  {
    code: "MAC010",
    recommendations: {
      sfp_e: productUrl[18],
      svd: productUrl[17],
    },
  },
  {
    code: "MAC011",
    recommendations: {
      sfp_e: productUrl[18],
      svd: productUrl[17],
    },
  },
  {
    code: "MAC146",
    recommendations: {
      sfp_e: productUrl[18],
      svd: productUrl[18],
    },
  },
  {
    code: "MAC012",
    recommendations: {
      svd: productUrl[17],
    },
  },
  {
    code: "MAC035",
    recommendations: {
      sfp_a: productUrl[8],
      sfp_e: productUrl[19],
      p_so: productUrl[20],
      svd: productUrl[2],
    },
  },
  {
    code: "MAC036",
    recommendations: {
      sfp_a: productUrl[8],
      sfp_e: productUrl[21],
      p_so: productUrl[20],
      svd: productUrl[2],
    },
  },
  {
    code: "MAC037",
    recommendations: {
      sfp_a: productUrl[8],
      sfp_e: productUrl[19],
      p_so: productUrl[20],
      svd: productUrl[2],
    },
  },
  {
    code: "MAC131",
    recommendations: {
      sfp_a: productUrl[14],
      sfp_e: productUrl[22],
      p_so: productUrl[23],
    },
  },
  {
    code: "MAC132",
    recommendations: {
      sfp_a: productUrl[17],
      sfp_e: productUrl[24],
      p_so: productUrl[25],
    },
  },
  {
    code: "MAC133",
    recommendations: {
      sfp_a: productUrl[26],
      sfp_e: productUrl[11],
      p_so: productUrl[14],
    },
  },
  {
    code: "MAC134",
    recommendations: {
      sfp_a: productUrl[3],
      sfp_e: productUrl[27],
      p_so: productUrl[7],
    },
  },
  {
    code: "MAC135",
    recommendations: {
      sfp_a: productUrl[23],
      sfp_e: productUrl[7],
      p_so: productUrl[2],
    },
  },
  {
    code: "MAC136",
    recommendations: {
      sfp_a: productUrl[2],
      sfp_e: productUrl[18],
      p_so: productUrl[6],
    },
  },
];
